const addPropToObj = (obj, key, prop = null) => ({ ...obj, [key]: prop });

export default addPropToObj;
